<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('messages')"
      :columns="columns"
      :column_search="true"
      :extra_data="{ template_uuid: $route.query.u }"
      resource_url="/outbox/message/datatables"
    >
      <!-- <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template> -->
    </generic-table>
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
} from "@/utils";

export default {
  name: "MessagesDatatable",
  components: { GenericTable },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          name: "create_date",
          width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date_time(row.create_date) || "";
          },
        },
        {
          title: v.$t("to"),
          name: "to",
          width: "25%",
          data: (row) => {
            let status_icon = "";
            if (row.status_code == "R") {
              status_icon = `<span class="icon has-text-warning"><i class="fa fa-clock-o"></i></span>`;
            } else if (row.status_code === "S") {
              status_icon = `<span class="icon has-text-success"><i class="fa fa-check"></i></span>`;
            } else if (row.status_code === "E") {
              status_icon = `<span class="icon has-text-danger"><i class="fa fa-remove"></i></span>`;
            } else {
              status_icon = `<span class="icon has-text-info"><i class="fa fa-info"></i></span>`;
            }
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `${status_icon} ${row.to}` || "";
          },
        },
        {
          title: v.$t("template"),
          // name: "name",
          searchable: false,
          width: "30%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.template.name || "";
          },
        },
        {
          title: v.$t("log"),
          // name: "name",
          searchable: false,
          width: "25%",
          data: (row) => {
            let list_items = row.status_log.reduce((prev, curr) => {
              return `${prev}<li>${format_date_time(curr.date)} - ${v.$t(
                curr.name
              )}</li>`;
            }, "");
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<ul>${list_items}</ul>`;
          },
        },
        {
          title: v.$t("options"),
          width: "5%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete message?"),
                    v,
                    () => {
                      del("/outbox/message", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.template_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
